@if (urlObject) {
  <app-object-url
    [object]="urlObject"
    [currentObjectName]="sectionsContainer?.rootObject?.artifact_name ?? ''"
    [disable]="edit"
    [aClass]="'object-view-field-value-link'"
  >
    <span
      class="object-url-content"
      [innerHTML]="fieldValue.value"
    ></span>
  </app-object-url>
}

@if (imageObject) {
  <app-thumbnail
    class="object-view-field-value__thumbnail"
    [item]="imageObject"
  ></app-thumbnail>
}

@if (url) {
  <a
    class="object-view-field-value__link"
    [attr.href]="fieldValue.value"
    target="_blank"
  >
    {{ fieldValue.value }}
  </a>
}

@if (!urlObject && fieldValue.is_text) {
  <app-auto-expandable-overflow-container
    [showMoreText]="'TRANS__OBJECT_VIEW_FIELD_VALUE__SHOW_MORE' | translate"
    [showLessText]="'TRANS__OBJECT_VIEW_FIELD_VALUE__SHOW_LESS' | translate"
  >
    <p
      [matTooltip]="'TRANS__OBJECT_VIEW_FIELD_VALUE__CONTAINS_DELETED_TOOLTIP' | translate"
      [matTooltipDisabled]="fieldValueClass !== 'contains-deleted'"
      matTooltipPosition="above"
      class="text-area-field-view {{fieldValueClass}}" readonly
    >
      {{ fieldValue.value }}
    </p>
  </app-auto-expandable-overflow-container>
}

@if (!urlObject && !imageObject && !url && !fieldValue.is_text) {
 <span
   [innerHTML]="fieldValue.value"
 ></span>
}
